import { Spin } from 'antd';
import styled from 'styled-components';
import { LoadingOutlined } from '@ant-design/icons';

const LoadingSpinner = () => {
  return (
    <StyledLoadingSpinner data-testid="loader" data-cy="loading-spinner">
      <Spin indicator={<LoadingOutlined spin />} size="large" />
    </StyledLoadingSpinner>
  );
};

export default LoadingSpinner;

const StyledLoadingSpinner = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  background: rgba(255, 255, 255, 0.8);
  z-index: 1000;
  display: block;
  width: 100%;
  height: 100%;
  .ant-spin {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }
`;
